module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point1_6-c6809b1449d451ae9d9ca66a9863a2b4.jpg";